module.exports = __webpack_public_path__ + "static/media/wifi_lock.66b659c1.svg";